/**
 * @since 7.1.0
 */
export interface DeleteRemindersByIdOptions {
  /**
   * @since 7.1.0
   */
  ids: string[];
}
